'use strict';

var _ = require('lodash');
var RecommendationCompetitorPanelController = function RecommendationCompetitorPanelController($scope, configurationService, MomentService, $filter, faresOptimizerCompetitorLadderDataService, competitorPanelChartService, dataUtilsService, mapHostLadderService, app, FaresOptimizerConstants, faresOptimizerWebFareChartTransformationService, faresOptimizerSaveAdjustedFaresService) {
  var rmMomentFormat = $filter('rmMomentFormat');
  var applicableDateLabels = [{
    field: 'tripType',
    label: ''
  }, {
    field: 'fareBrandName',
    label: ' '
  }, {
    field: 'season',
    label: 'Season'
  }, {
    field: 'dow',
    label: 'DOW'
  }, {
    field: 'ap',
    label: 'AP'
  }, {
    field: 'mms',
    label: 'MMS'
  }, {
    field: 'currencyCode',
    label: 'Currency'
  }];
  var currencyCode;
  function getHostLadderData(ladder) {
    return _.chain(ladder.groupedRows).map(function (row) {
      row.rbdIndex = _.indexOf(app.foRbds, row.rbd);
      return row;
    }).sortBy('rbdIndex').reduce(function (hostLadder, groupedRow) {
      hostLadder.push({
        market: groupedRow.market,
        rbd: groupedRow.rbd,
        fbc: groupedRow.fbc,
        effectiveTotalFare: groupedRow.effectiveTotalFare,
        recommendedTotalFare: groupedRow.recommendedFareTotal,
        minFareThreshold: groupedRow.minFareThreshold,
        maxFareThreshold: groupedRow.maxFareThreshold,
        sponsorMarketFbc: groupedRow.sponsorMarketFbc,
        dualRbdSponsorFbc: groupedRow.dualRbdSponsorFbc,
        percentageLinkageFactor: groupedRow.percentageLinkageFactor,
        absoluteLinkageFactor: groupedRow.absoluteLinkageFactor,
        benchmarkFareComponent: groupedRow.benchmarkFareComponent,
        yq: groupedRow.yq,
        yr: groupedRow.yr,
        q: groupedRow.q,
        airportTax: groupedRow.airportTax,
        variable: groupedRow.variable,
        qMisc: groupedRow.qMisc,
        variableTaxPercentage: groupedRow.variableTaxPercentage,
        useForLadderGenerationInd: groupedRow.useForLadderGenerationInd,
        isMappedRbd: groupedRow.isMappedRbd,
        actionCode: groupedRow.actionCode
      });
      return hostLadder;
    }, []).value();
  }
  function getWebFareChartData(webFareDetails) {
    return {
      title: webFareDetails.carrier,
      tripType: webFareDetails.fareTypeIndicator,
      data: webFareDetails.webFares
    };
  }
  function getFareChartGroupedRows(ladder, selectedCompetitorKeys) {
    return _.map(ladder.groupedRows, function (groupedRow) {
      if (groupedRow.selectedCompetitorKey) {
        selectedCompetitorKeys.push(groupedRow.selectedCompetitorKey);
      }
      var groupedRowFields = ['actionCode', 'rbd', 'fbc', 'minFareThreshold', 'maxFareThreshold', 'currentFareBase', 'currentFareTotal', 'effectiveBaseFare', 'effectiveTotalFare', 'recommendedFareBase', 'distributedFare', 'fareChangeAbsolute', 'effectiveFareChangeAbsolute', 'recommendedFareTotal', 'yq', 'yr', 'q', 'airportTax', 'variable', 'recommendedVariable', 'effectiveVariable', 'hasLinkedFbc', 'isLinkedFbc', 'isDualRbdFare', 'isSharedFbc', 'qMisc', 'benchmarkFareComponent', 'linkedFbcs', 'sharedEntryLevelFbcList', 'fareBrand', 'useForLadderGenerationInd', 'isMappedRbd', 'isEntryLevel', 'userAdjustedDates', 'selectedCompetitorKey'];
      if (ladder.hostHighestFbc !== groupedRow.fbc && !_.isEmpty(groupedRow.selectedCompetitorKey)) {
        groupedRowFields = groupedRowFields.concat(_.keys(faresOptimizerSaveAdjustedFaresService.getUserAdjustedDatesRequiredFields()));
      }
      var fareChartGroupedRows = _.pick(groupedRow, groupedRowFields);
      fareChartGroupedRows.category = ladder.category;
      fareChartGroupedRows.fareRecommendationRecordKey = ladder.fareRecommendationRecordKey;
      return fareChartGroupedRows;
    });
  }
  function getFareChartHostData(ladder, webFareByCarrier) {
    var selectedCompetitorKeys = [];
    var createdAt = MomentService.of(ladder.createdAt, MomentService.TYPE.LOCAL_DATE);
    var groupedRows = getFareChartGroupedRows(ladder, selectedCompetitorKeys);
    // TODO: when only for web fare, not sure why we have to populate the rest
    // TODO: without doing this way, it kind off breaks!
    var webFareData = !_.isNil(webFareByCarrier) ? getWebFareChartData(webFareByCarrier) : undefined;
    var fareChartHostData = {
      fareRecommendationRecordKey: ladder.fareRecommendationRecordKey,
      groupedRows: groupedRows,
      fbc: ladder.fbc,
      status: ladder.status,
      displayStatus: ladder.status,
      createdDate: rmMomentFormat(createdAt, 'DATE_USER_SETTINGS'),
      pos: ladder.pos,
      alignedWith: ladder.alignedWith,
      hasSharedFbc: ladder.hasSharedFbc,
      allSharedEntryLevelFbcList: ladder.allSharedEntryLevelFbcList,
      allSharedFbcLadderIds: ladder.allSharedFbcLadderIds,
      userAdjustedDates: ladder.userAdjustedDates,
      allFaresCancelled: ladder.allFaresCancelled,
      hasTargetFaresDiscontinued: ladder.areTargetFaresDiscontinued,
      createdAt: ladder.createdAt,
      recommendationEffectiveDate: ladder.recommendationEffectiveDate,
      webFareData: webFareData,
      ladderGenerationMethod: ladder.ladderGenerationMethod,
      isFootnoteUpdated: ladder.isFootnoteUpdated,
      isRuleUpdated: ladder.isRuleUpdated,
      isDiscontinueRule: ladder.isDiscontinueRule,
      isAdvancePurchaseUpdated: ladder.isAdvancePurchaseUpdated,
      hostHighestFbc: ladder.hostHighestFbc
    };
    populateSeasonForEntryLevelData(ladder);
    ladder.selectedCompetitorKeys = selectedCompetitorKeys;
    _.extend(fareChartHostData, ladder.entryLevelFbcData);
    return fareChartHostData;
  }
  function populateSeasonForEntryLevelData(ladder) {
    if (!_.isNil(ladder) && !_.isNil(ladder.entryLevelFbcData)) {
      ladder.entryLevelFbcData.season = ladder.season;
    }
  }
  function getSmoothingMethods() {
    return configurationService.getFoSmoothingMethods();
  }
  function setMappedRbds(ladder, selectedCompetitorKeys) {
    _.map(ladder.competitorLadder, function (compLadder) {
      var compKey = [ladder.competitorCarrier, ladder.competitorOrigin, ladder.competitorDestination, compLadder.fareBasisCode, compLadder.routingNumber, compLadder.tariffCode, compLadder.footnote].filter(Boolean).join('-');
      compLadder.isMappedRbd = selectedCompetitorKeys.indexOf(compKey) !== -1;
      if (compLadder.isMappedRbd === true) {
        ladder.selectedCompetitorFbc = compLadder.fareBasisCode;
      }
    });
  }
  function getApplicableCompetitorFareLadder(selectedFareLadder, competitorData) {
    var applicableCompetitorFareLadder;
    var competitorLadders = $scope.screenState.recommendationDetailsPanel.competitorLadders;
    if (!_.isEmpty(competitorData)) {
      applicableCompetitorFareLadder = _.find(competitorLadders, function (ladder) {
        setMappedRbds(ladder, selectedFareLadder.selectedCompetitorKeys);
        if (_.isUndefined(ladder.competitorFootnote) || _.isUndefined(competitorData.footnote)) {
          return (ladder.competitorEntryLevelFbc === competitorData.fbc || ladder.selectedCompetitorFbc === competitorData.fbc) && ladder.competitorRoutingNumber === competitorData.routingNumber && ladder.competitorTariffCode === competitorData.tariffCode;
        } else {
          return (ladder.competitorEntryLevelFbc === competitorData.fbc || ladder.selectedCompetitorFbc === competitorData.fbc) && ladder.competitorRoutingNumber === competitorData.routingNumber && ladder.competitorTariffCode === competitorData.tariffCode && ladder.competitorFootnote === competitorData.footnote;
        }
      });
    }
    if (_.isEmpty(applicableCompetitorFareLadder)) {
      return {};
    }
    competitorData.competitorFareLadder = applicableCompetitorFareLadder.competitorLadder;
    return competitorData;
  }
  function buildChartData(selectedFareLadder) {
    $scope.chartDataList = [];
    currencyCode = selectedFareLadder.groupedRows[0].currencyCode;
    $scope.recommendedFareChartData = $scope.setUpChartData(getFareChartHostData(selectedFareLadder), true, false, false, false);
    $scope.currentFareChartData = $scope.setUpChartData(getFareChartHostData(selectedFareLadder));
    $scope.chartDataList.push($scope.recommendedFareChartData, $scope.currentFareChartData);
    selectedFareLadder.category === FaresOptimizerConstants.CATEGORY.STRUCTURAL ? structuralChartData(selectedFareLadder) : tacticalChartData(selectedFareLadder);
    $scope.entryLevelEffectiveFare = $scope.setUpChartData(getFareChartHostData(selectedFareLadder), false, true, false, false);
    $scope.entryLevelEffectiveFare.data.showAdjustFares = false;
    $scope.chartDataList.push($scope.entryLevelEffectiveFare);
  }
  function setWebFareChartDataByCarrier(selectedFareLadder, webFaresByCarriers) {
    $scope.chartDataList = _.isNil($scope.chartDataList) ? [] : $scope.chartDataList;
    $scope.webFaresData = [];
    var indexOfEffectiveFare = getIndexOfEffectiveFareChart(webFaresByCarriers);
    var today = MomentService.systemNow(MomentService.TYPE.LOCAL_DATE);
    _.map(webFaresByCarriers, function (webFareByCarrier) {
      // filter out records which are from today to future
      var filteredWebFaresDetails = faresOptimizerWebFareChartTransformationService.getWebFaresFromDateAndCheckForTodayRecord(webFareByCarrier.webFares, today);
      if (filteredWebFaresDetails.filteredWebFares.length > 0) {
        // only if we have at least one record to plot the graph
        webFareByCarrier.webFares = filteredWebFaresDetails.filteredWebFares;
        var webFaresByCarrierData = $scope.setUpChartData(getFareChartHostData(selectedFareLadder, webFareByCarrier), false, false, false, true);
        webFaresByCarrierData.data = _.cloneDeep(faresOptimizerWebFareChartTransformationService.fillDummyDates(webFaresByCarrierData.data, filteredWebFaresDetails.isExistTodayRecord, today));
        $scope.chartDataList.splice(indexOfEffectiveFare++, 0, webFaresByCarrierData);
        $scope.webFaresData.push(webFaresByCarrierData);
      }
    });
  }
  function getIndexOfEffectiveFareChart(webFaresByCarriers) {
    var indexOfEffectiveFare = 0;
    if (webFaresByCarriers && webFaresByCarriers.length > 0) {
      // the web fare chart should be displayed just before the effective fare chart
      indexOfEffectiveFare = _.findIndex($scope.chartDataList, function (list) {
        return list.title.indexOf(FaresOptimizerConstants.EFFECTIVE_FARES_CHART_TITLE) > -1;
      });
    }
    return indexOfEffectiveFare;
  }
  function buildChartDataForWebFares(selectedFareLadder) {
    var webFaresByCarrier = selectedFareLadder.category === FaresOptimizerConstants.CATEGORY.STRUCTURAL ? structuralWebFareChartData() : tacticalWebFareChartData();
    setWebFareChartDataByCarrier(selectedFareLadder, webFaresByCarrier);
  }
  function structuralChartData(selectedFareLadder) {
    $scope.chartDataList.push($scope.setUpChartData(getApplicableCompetitorFareLadder(selectedFareLadder, selectedFareLadder.competitorData1), false, false, true, false));
    $scope.chartDataList.push($scope.setUpChartData(getApplicableCompetitorFareLadder(selectedFareLadder, selectedFareLadder.competitorData2), false, false, true, false));
    $scope.chartDataList.push($scope.setUpChartData(getApplicableCompetitorFareLadder(selectedFareLadder, selectedFareLadder.competitorData3), false, false, true, false));
  }
  function structuralWebFareChartData() {
    var webFaresByCarrierAndFareType = _.cloneDeep($scope.screenState.recommendationDetailsPanel.webFaresByCarrierAndFareType) || [];
    return webFaresByCarrierAndFareType.splice(0, 3);
  }
  function tacticalWebFareChartData() {
    return _.cloneDeep($scope.screenState.recommendationDetailsPanel.webFaresByCarrierAndFareType);
  }
  function tacticalChartData(selectedFareLadder) {
    var entryLevelBenchmark = $scope.screenState.recommendationDetailsPanel.selectedHostLadder.data.entryLevelBenchmark;
    var competitorsFares = _.chain(entryLevelBenchmark).filter(function (competitorData) {
      return competitorData.matchPercentage > 0 && !mapHostLadderService.isCompetitorAlreadySelectedByAnotherLadder(competitorData.fbc, _.cloneDeep(selectedFareLadder));
    }).orderBy([sortCompetitor], ['desc']).value();
    var selectedCompetitor = _.isEmpty(selectedFareLadder.selectedCompetitorData) ? undefined : selectedFareLadder.selectedCompetitorData;
    if (!_.find(competitorsFares, {
      isSelectedCompetitor: true
    }) && selectedCompetitor) {
      selectedCompetitor = _.find(entryLevelBenchmark, {
        isSelectedCompetitor: true
      });
      competitorsFares.unshift(selectedCompetitor);
    }
    selectedFareLadder.competitorsData = [];
    _.each(competitorsFares, function (competitorFare) {
      var competitorData = getApplicableCompetitorFareLadder(selectedFareLadder, transformBenchmarkLevel(competitorFare));
      selectedFareLadder.competitorsData.push(competitorData);
      $scope.chartDataList.push($scope.setUpChartData(competitorData, false, false, true, false));
    });
  }
  function sortCompetitor(competitorData) {
    if (competitorData.isSelectedCompetitor) {
      return 999;
    }
    return competitorData.matchPercentage;
  }
  function transformBenchmarkLevel(entryLevelBenchmark) {
    var outboundDaysOfWeek = dataUtilsService.convertDayOfWeekNumber(entryLevelBenchmark.daysOfWeek);
    var competitorData = Object.assign({}, entryLevelBenchmark);
    competitorData.season = dataUtilsService.getSeasonDefinition(entryLevelBenchmark.seasonIndicator, entryLevelBenchmark.fbc) || '-';
    competitorData.ap = entryLevelBenchmark.ap || '-';
    competitorData.dow = outboundDaysOfWeek;
    competitorData.minStay = entryLevelBenchmark.minStay || '';
    competitorData.maxStay = entryLevelBenchmark.maxStay || 0;
    competitorData.mms = competitorData.minStay + ' - ' + competitorData.maxStay;
    competitorData.isSelected = entryLevelBenchmark.isSelected;
    competitorData.isActive = entryLevelBenchmark.isActive;
    return competitorData;
  }
  function setAdjustEffectiveFareData(selectedFareLadder) {
    $scope.entryLevelEffectiveFare.hostLadder = getHostLadderData(selectedFareLadder);
    $scope.entryLevelEffectiveFare.smoothingMethods = getSmoothingMethods();
    $scope.entryLevelEffectiveFare.status = selectedFareLadder.status;
    $scope.entryLevelEffectiveFare.recomId = selectedFareLadder.fareRecommendationRecordKey;
  }
  function getCompetitorLadderSearchCriteria(ladder) {
    return 'hostRecommendationKey == ' + ladder.fareRecommendationRecordKey;
  }
  function getSelectedLadderIndex() {
    var fareLaddersInGroup = $scope.screenState.recommendationDetailsPanel.ladderGroupChartDataList;
    var currentSelectedFareLadder = $scope.screenState.recommendationDetailsPanel.selectedHostLadder;
    return fareLaddersInGroup.indexOf(currentSelectedFareLadder);
  }
  function buildDataForRenderingCharts(fareLadder) {
    buildChartData(fareLadder);
    $scope.entryLabels = fareLadder.entryLabels;
    setAdjustEffectiveFareData(fareLadder);
    $scope.settings = competitorPanelChartService.getFareChartScaleSettings(fareLadder);
  }
  function getCompetitorFareLadderData(fareLadder) {
    var cachedLadder = _.find($scope.screenState.competitorLadderData, {
      hostRecommendationKey: fareLadder.fareRecommendationRecordKey
    });
    if (cachedLadder) {
      $scope.screenState.recommendationDetailsPanel.competitorLadders = cachedLadder.competitorLadder;
      buildDataForRenderingCharts(fareLadder);
      buildChartDataForWebFares(fareLadder);
      return;
    }
    var searchCriteria = getCompetitorLadderSearchCriteria(fareLadder);
    faresOptimizerCompetitorLadderDataService.getCompetitorLadderData(searchCriteria).then(function (data) {
      var competitorLadder = {
        hostRecommendationKey: fareLadder.fareRecommendationRecordKey,
        competitorLadder: []
      };
      if (!_.isEmpty(data)) {
        competitorLadder = {
          hostRecommendationKey: data[0].hostRecommendationKey,
          competitorLadder: data
        };
      }
      $scope.screenState.competitorLadderData.push(competitorLadder);
      $scope.screenState.recommendationDetailsPanel.competitorLadders = data;
      buildDataForRenderingCharts(fareLadder);
      buildChartDataForWebFares(fareLadder);
    });
  }
  $scope.$watch('screenState.recommendationDetailsPanel.selectedHostLadder', function () {
    var contextData = $scope.screenState.recommendationDetailsPanel.contextData;
    var selectedHostLadder = $scope.screenState.recommendationDetailsPanel.selectedHostLadder.data;
    if (contextData && !_.isEmpty(contextData) && selectedHostLadder && !_.isEmpty(selectedHostLadder)) {
      getCompetitorFareLadderData(selectedHostLadder);
    }
    $scope.moveNextLadderAvailable = $scope.isNextLadderAvailable();
    $scope.movePreviousLadderAvailable = $scope.isPreviousLadderAvailable();
  }, true);
  function getEntryTitle(entry, isRecommendation, isEffective, isCompetitor, isWebFare) {
    var entryTitle = '';
    if (isWebFare) {
      entryTitle = entry.webFareData.title + ': ' + FaresOptimizerConstants.WEB_FARE_CHART_TITLE + ': ' + entry.webFareData.tripType;
    } else {
      var hostFbc = 'HOST: *' + entry.fbc.slice(1) + ': ';
      if (isCompetitor) {
        hostFbc = '';
        var compMarketFbc = entry.fbc + '(' + entry.compMarket + ')';
        entryTitle = entry.fareSource + ': ' + entry.carrier + ': ' + compMarketFbc + ': ' + entry.matchPercentage + '% Match';
      } else if (isRecommendation) {
        entryTitle = FaresOptimizerConstants.RECOMMENDATION_CHART_TITLE;
      } else if (isEffective) {
        entryTitle = FaresOptimizerConstants.EFFECTIVE_FARES_CHART_TITLE;
      } else {
        // else current
        entryTitle = FaresOptimizerConstants.CURRENT_FARE_CHART_TITLE;
      }
      entryTitle = hostFbc + entryTitle;
    }
    return entryTitle;
  }
  $scope.setUpChartData = function (entry, isRecommendation, isEffective, isCompetitor, isWebFare) {
    if (!_.isEmpty(entry)) {
      var entryTitle = getEntryTitle(entry, isRecommendation, isEffective, isCompetitor, isWebFare);
      var isActive = false;
      if (_.isNil(entry.alignedWith) && entryTitle.indexOf(FaresOptimizerConstants.RECOMMENDATION_CHART_TITLE) > -1 || !_.isNil(entry.alignedWith) && entryTitle.indexOf(entry.alignedWith) > -1 || entry.isActive) {
        isActive = true;
      }
      return {
        title: entryTitle,
        data: isWebFare ? entry.webFareData.data : entry,
        labels: mapLabels(entry, applicableDateLabels),
        isActive: isActive
      };
    } else {
      return {
        title: 'No competitor',
        data: {},
        labels: []
      };
    }
  };
  $scope.$emit('comp_window_disable_panel');
  function mapLabels(sourceItem, labelFields) {
    return _.map(labelFields, function (groupingItem) {
      var value = !_.isNil(sourceItem[groupingItem.field]) ? sourceItem[groupingItem.field] : '';
      if (groupingItem.field === 'currencyCode') {
        value = currencyCode;
      }
      return groupingItem.field === 'season' ? value + ' ' + groupingItem.label : groupingItem.label + ' ' + value;
    });
  }
  function getLadderList() {
    return $scope.screenState.recommendationDetailsPanel.ladderGroupChartDataList;
  }
  function isAnyLadderSelected() {
    return getLadderList() && getSelectedLadderIndex() !== -1;
  }
  $scope.isPreviousLadderAvailable = function () {
    return isAnyLadderSelected() && getSelectedLadderIndex() > 0;
  };
  $scope.isNextLadderAvailable = function () {
    return isAnyLadderSelected() && getSelectedLadderIndex() < getLadderList().length - 1;
  };
  $scope.displayPrevious = function () {
    var fareLaddersInGroup = $scope.screenState.recommendationDetailsPanel.ladderGroupChartDataList;
    var currentSelectedLadderIndex = getSelectedLadderIndex();
    var newSelectedLadderIndex = currentSelectedLadderIndex - 1;
    if (currentSelectedLadderIndex > 0) {
      $scope.screenState.recommendationDetailsPanel.selectedHostLadder = fareLaddersInGroup[newSelectedLadderIndex];
    }
    $scope.moveNextLadderAvailable = $scope.isNextLadderAvailable();
    $scope.movePreviousLadderAvailable = $scope.isPreviousLadderAvailable();
  };
  $scope.displayNext = function () {
    var fareLaddersInGroup = $scope.screenState.recommendationDetailsPanel.ladderGroupChartDataList;
    var currentSelectedLadderIndex = getSelectedLadderIndex();
    var nextSelectedLadderIndex = currentSelectedLadderIndex + 1;
    if (fareLaddersInGroup.length > nextSelectedLadderIndex) {
      $scope.screenState.recommendationDetailsPanel.selectedHostLadder = fareLaddersInGroup[nextSelectedLadderIndex];
    }
    $scope.moveNextLadderAvailable = $scope.isNextLadderAvailable();
    $scope.movePreviousLadderAvailable = $scope.isPreviousLadderAvailable();
  };

  // handle toggle between total and base Web Fare
  $scope.$on('chart.webfare.toggle.faretype', function (evt, webFareByCarrier) {
    $scope.$broadcast('chart.webfare.toggle.faretype.data', webFareByCarrier);
  });
};
RecommendationCompetitorPanelController.$inject = ['$scope', 'ConfigurationService', 'MomentService', '$filter', 'FaresOptimizerCompetitorLadderDataService', 'CompetitorPanelChartService', 'FaresOptimizerAnalysisDataUtilsService', 'FaresOptimizerMapHostLadderSelectedCompetitorService', 'App', 'FaresOptimizerConstants', 'FaresOptimizerWebFareChartTransformationService', 'FaresOptimizerSaveAdjustedFaresService'];
module.exports = RecommendationCompetitorPanelController;